// JamLabs dev: the web app at https://tpicaptca.dev.jamlabs.com (tpicap-tca-frontend-jld), with
// dashboards from NPD Jitto, the tca-npd tenant JamLabs hosts (AWS 253507260626, London). For now its
// cloud functions are TP ICAP's npd ones; they move to jamlabs-tca-dev later.
const host = 'https://europe-west2-prj-tca-npd-0d74.cloudfunctions.net';

const dashboards = {
  fixedincome: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `22839260-2cb5-4cf1-885a-15b55ea3a8c7`,
      tradedetails: `58f090aa-da99-4f12-8242-11c145769d06`,
      outliers: `6bb93637-3008-4965-b433-05801054b10d`,
      pmoverview: `6bf6703e-e421-40ab-9ac1-0a12f78f08a2`,
      traderoverview: `150d0a28-7866-4624-aeb7-b0d10eb7395c`,
    },
    worksheetId: `fd59b959-4458-4f2f-b759-9931870bf995`,
  },
  fx: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `6a137fab-6cad-4129-92b9-778f01aa434e`,
      tradedetails: `5023493e-a2d4-4932-aa92-9e57109103e1`,
      outliers: `d51bb235-73f6-4b8e-98cd-6fa28b848bd7`,
      pmoverview: `na`,
      traderoverview: `na`,
    },
    worksheetId: `ca098e13-d20f-4e2f-9c3d-89b39f6e6635`,
  },
  fxforward: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `353d9f45-b507-46a7-86e0-9a2ad758059a`,
      tradedetails: `1d7804f3-54bb-4980-a1ac-bd946117677f`,
      outliers: `2b4f05bd-2b48-49ee-a662-7ec615271f15`,
      pmoverview: `na`,
      traderoverview: `na`,
    },
    worksheetId: `4f874cbd-fbd0-4472-b475-def1e0aa9f61`,
  },
  // Jitto Answer only: TCA has no ThoughtSpot FX Swap dashboard, so the route
  // id is the embedded uuid itself (config/jittoDashboards.json).
  fxswap: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `na`,
      tradedetails: `3a37eef7-1625-5d3c-9bd3-97d8c60c9cdf`,
      outliers: `na`,
      pmoverview: `na`,
      traderoverview: `na`,
    },
    worksheetId: ``,
  },
  irs: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: '5f6981b9-d924-44fe-bec5-ec0c44298d85',
      tradedetails: 'cfe8c345-f161-472c-a2e6-fc74f0672f7c',
      outliers: `6db2e0ec-ebe5-4e5f-9f9e-8eaa25defe90`,
      pmoverview: 'na',
      traderoverview: 'na',
    },
    worksheetId: `538c7f74-dbcd-4b98-bb25-37ae7e4d53b0`,
  },
};

const config = {
  uploadsItemsPerPage: 7,
  uploadsPaginationItems: 10,
  uploadsPreviewColumns: 8,
  bepActiveFlag: true,
  repLinearActiveFlag: true,
  fepSpotActiveFlag: true,
  fepForwardsActiveFlag: true,
  fepNonLinearActiveFlag: false,
  endpoints: {
    uploadDetails: `${host}/upload-details`,
    getUploadUrl: `${host}/get-upload-url`,
    uploads: `${host}/uploads`,
    mapUpload: `${host}/map-upload`,
    downloadFile: `${host}/download-file`,
    deleteIngest: `${host}/delete-ingest`,
    cancelIngest: `${host}/cancel-ingest`,
    requestAccount: `${host}/request-account`,
    approveVerificationReport: `${host}/approve-verification-report`,
    getUserData: `${host}/get-user-data`,
    verifyUserToken: `${host}/verify-user-token`,
    getThoughtSpotToken: `${host}/get-thoughtspot-token`,
    getJittoEmbedToken: `${host}/get-jitto-embed-token`,
    preferences: `${host}/user-preferences`,
    getLogUrl: `${host}/get-log-url`,
    mappingAdmin: `${host}/mapping-admin`,
    mappingAdminValues: `${host}/mapping-admin-values`,
    getMappingAuditTrail: `${host}/mapping-audit-trail`,
  },
  uploadValidationPollInterval: 5000,
  oktaAccountManagementLink:
    'https://parameta-accounts.okta.com/enduser/settings?fromLogin=true',
  // Jitto Answer embed (ANS-545): on. If the backend cannot mint
  // a token the page logs it and shows a notice. When on, a
  // dashboard with an embedded uuid in config/jittoDashboards.json renders from
  // Jitto Answer and every other one shows a notice; nothing asks ThoughtSpot
  // (no ThoughtSpot embed, AI Assistant, dashboard builder or logout). When off,
  // all of it is ThoughtSpot.
  jittoEmbedActiveFlag: true,
  // NPD Jitto's embed host, hosted by JamLabs (jitto-analyze deploy/tenants/tpicap/npd):
  // @jitto/analyze-embed frames only <this>/embed (ANS-678).
  jittoEmbedOrigin: 'https://embed.tpicap-tca-npd.jitto.jamlabs.com',
  // Jitto applies host filters (filters on mount, setFilters): @jitto/analyze-embed 0.3.0, and
  // NPD Jitto (above) runs jitto-analyze#540 with EMBED_HOST_FILTERS on and single_choice listed
  // (29 Oct, ANS-801). The currency picker drives the dashboard's Ccy filter.
  jittoHostFilters: true,
  thoughtSpotHost: 'https://parameta.thoughtspot.cloud',
  authProvider: 'okta',
  okta: {
    issuer: 'https://parameta-accounts.okta.com/oauth2/default',
    clientId: '0oa131qon7hilhvva417',
    pkce: false,
    tokenManager: {
      storage: 'sessionStorage',
    },
    cookies: {
      sessionCookie: true,
    },
  },
  fxCurrencies: [
    'USD',
    'CAD',
    'CNY',
    'CHF',
    'AUD',
    'JPY',
    'EUR',
    'GBP',
    'NZD',
    'HKD',
    'SEK',
    'SGD',
  ].sort(),
  requestAccountActionURL:
    'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
  requestAccountRetURL: 'https://tpicaptca.dev.jamlabs.com/requestaccount',
  dashboards,
};

export default config;
